import { render, staticRenderFns } from "./Goodbye.vue?vue&type=template&id=11fcc924&scoped=true"
import script from "./Goodbye.vue?vue&type=script&lang=ts"
export * from "./Goodbye.vue?vue&type=script&lang=ts"
import style0 from "./Goodbye.vue?vue&type=style&index=0&id=11fcc924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fcc924",
  null
  
)

export default component.exports